'use client';

import { Link } from 'react-router-dom';
import { ArrowLeft, Truck, Phone, MapPin, User } from 'lucide-react';
import Footer from '@/components/Footer';


const GUINCHOS = [
  { name: "Ribeiro Auto Socorro", number: "(45) 99965-1710", address: "Atendimento 24h", icon: <User />, color: "bg-slate-600", whatsapp: "https://wa.me/5545999651710" },
  { name: "Zaror Auto Socorro", number: "(45) 99145-8010", address: "Atendimento 24h", icon: <User />, color: "bg-slate-700", whatsapp: "https://wa.me/5545991458010" },
];

export default function GuinchosPage() {
  return (
    <div className="min-h-screen bg-slate-50 font-sans text-slate-900 selection:bg-slate-200 selection:text-slate-900">
      {/* Header */}
      <header className="bg-gradient-to-r from-slate-600 to-slate-800 text-white shadow-lg">
        <div className="max-w-4xl mx-auto px-4 py-12 md:py-20 text-center space-y-6">
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 bg-white/10 hover:bg-white/20 backdrop-blur-sm border border-white/30 px-6 py-3 rounded-2xl text-white font-black uppercase tracking-tighter italic transition-all hover:-translate-x-1 active:scale-95 mb-8 group shadow-lg"
          >
            <ArrowLeft className="w-5 h-5 group-hover:-translate-x-1 transition-transform" />
            Voltar para o Início
          </Link>
          <h1 className="text-3xl md:text-5xl font-black tracking-tighter uppercase italic">
            Guinchos <br className="md:hidden" />
            <span className="text-slate-200">Catanduvas PR</span>
          </h1>
          <p className="text-slate-100 text-lg md:text-xl font-medium max-w-2xl mx-auto">
            Precisa de um guincho? Encontre aqui os contatos de serviço de guincho na região.
          </p>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-4 -mt-8 pb-20">
        <div className="bg-white rounded-[2.5rem] p-8 md:p-12 shadow-2xl border border-slate-100">
          <div className="flex items-center gap-3 mb-10">
            <div className="bg-slate-100 p-3 rounded-2xl">
              <Truck className="w-8 h-8 text-slate-600" />
            </div>
            <div>
              <h2 className="text-2xl font-black text-slate-800 uppercase tracking-tighter italic">Contatos Rápidos</h2>
              <p className="text-slate-500 font-bold text-sm">Clique para ligar ou chamar no WhatsApp</p>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {GUINCHOS.map((guincho, i) => (
              <div key={i} className="bg-slate-50 rounded-3xl p-6 border border-slate-100 flex flex-col justify-between group hover:bg-white hover:shadow-xl transition-all">
                <div className="flex items-start justify-between mb-6">
                  <div className="flex items-center gap-4">
                    <div className={`p-4 rounded-2xl text-white shadow-lg ${guincho.color}`}>
                      {guincho.icon}
                    </div>
                    <div>
                      <h3 className="text-xl font-black text-slate-800 uppercase tracking-tighter italic leading-none mb-2">{guincho.name}</h3>
                      <p className="text-slate-500 text-sm font-bold flex items-center gap-1">
                        <MapPin className="w-3 h-3" />
                        {guincho.address}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="flex gap-3">
                  <a 
                    href={`tel:${guincho.number.replace(/\D/g, '')}`}
                    className="flex-1 flex items-center justify-center gap-2 bg-white hover:bg-slate-100 text-slate-800 py-4 rounded-2xl font-black uppercase tracking-tighter italic border border-slate-200 transition-all active:scale-95 shadow-sm"
                  >
                    <Phone className="w-5 h-5 text-slate-600" />
                    {guincho.number}
                  </a>
                  {guincho.whatsapp && (
                    <a 
                      href={guincho.whatsapp}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="w-16 flex items-center justify-center bg-emerald-500 hover:bg-emerald-600 text-white rounded-2xl transition-all active:scale-95 shadow-lg shadow-emerald-100"
                    >
                      <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/></svg>
                    </a>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
